import { render, staticRenderFns } from "./AssignmentPreview.vue?vue&type=template&id=bac37ef2&"
import script from "./AssignmentPreview.vue?vue&type=script&lang=js&"
export * from "./AssignmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPreview.vue?vue&type=style&index=0&id=bac37ef2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports